// @flow @format
import React, {Component, type Node} from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './CoreLayout.css';

type Props = {
	header: Node,
	main: Node,
	footer: Node,
};

class CoreLayout extends Component<Props> {
	static propTypes = {
		header: PropTypes.element.isRequired,
		main: PropTypes.element.isRequired,
		footer: PropTypes.element.isRequired,
	};

	render() {
		return (
			<div className={classNames('CoreLayout', 'theme-light')}>
				<header className="CoreLayout__header">
					{this.props.header}
				</header>
				<main className="CoreLayout__main">
					{this.props.main}
				</main>
				<footer className="CoreLayout__footer">
					{this.props.footer}
				</footer>
			</div>
		);
	}
}

export default CoreLayout;



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js